import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { TESTIMONIALS } from "../data/content";

// Curated 3 for the home page teaser
const HIGHLIGHTS = [TESTIMONIALS[2], TESTIMONIALS[1], TESTIMONIALS[0]];

export default function RecommendationsTeaser() {
  return (
    <section className="relative z-10 py-24 md:py-32 bg-[#0B132B]/40" data-testid="home-recommendations-teaser">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-12">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 lg:gap-12 mb-14 items-end">
          <div className="lg:col-span-8">
            <p className="text-sm font-500 tracking-[0.3em] uppercase text-[#D95A41] mb-5">
              Recommendations
            </p>
            <h2 className="text-4xl md:text-6xl font-900 tracking-tightest leading-[1] text-[#F2EFE9] max-w-3xl">
              Trusted, in their own words.
            </h2>
          </div>
          <div className="lg:col-span-4 flex lg:justify-end">
            <Link
              to="/home/firm"
              data-testid="home-recommendations-cta"
              className="inline-flex items-center gap-2 text-sm font-700 tracking-[0.15em] uppercase text-[#94A3B8] hover:text-[#D95A41] transition-colors"
            >
              Read all recommendations <ArrowRight size={16} />
            </Link>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
          {HIGHLIGHTS.map((t, i) => (
            <div
              key={i}
              className="rounded-2xl border border-white/10 bg-[#050A14] p-7 flex flex-col hover:border-[#D95A41]/40 transition-colors"
              data-testid={`home-recommendation-${i}`}
            >
              <svg width="26" height="20" viewBox="0 0 32 24" className="text-[#D95A41] mb-4" fill="currentColor" aria-hidden="true">
                <path d="M0 24V13.6C0 9.6 0.906667 6.30667 2.72 3.72C4.56 1.24 7.09333 0 10.32 0V4.68C8.66667 4.68 7.34667 5.34667 6.36 6.68C5.37333 8.01333 4.88 9.86667 4.88 12.24H10.08V24H0ZM17.92 24V13.6C17.92 9.6 18.8267 6.30667 20.64 3.72C22.48 1.24 25.0133 0 28.24 0V4.68C26.5867 4.68 25.2667 5.34667 24.28 6.68C23.2933 8.01333 22.8 9.86667 22.8 12.24H28V24H17.92Z" />
              </svg>
              <p className="text-[15px] text-[#F2EFE9]/90 leading-relaxed flex-1 line-clamp-6">
                {t.text}
              </p>
              <div className="mt-5 pt-4 border-t border-white/10">
                <p className="font-700 text-[#F2EFE9] text-sm">{t.name}</p>
                <p className="text-xs text-[#94A3B8] mt-0.5" style={{ textAlign: "left" }}>{t.role}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
